/**
 * Route for `igaming-scheduled-on-demand-payout`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingScheduledOnDemandPayoutPage } from "../features/igaming-scheduled-on-demand-payout/IgamingScheduledOnDemandPayoutPage";

export const igamingScheduledOnDemandPayoutRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-scheduled-on-demand-payout",
	component: IgamingScheduledOnDemandPayoutPage,
});

export default igamingScheduledOnDemandPayoutRoute;
